import { operatorLabels } from './operatorLabels';

export function getOperatorLabel(operator) {
    if ('label' in operator && operator.label === null) return null;

    return operator.label ?? operatorLabels[operator.id] ?? operator.id;
}
